import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Could send to error tracking service in production
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '60vh', display: 'flex', alignItems: 'center',
          justifyContent: 'center', flexDirection: 'column', gap: '16px',
          textAlign: 'center', padding: '32px',
        }}>
          <h2 style={{ fontSize: '1.3rem' }}>Something went wrong</h2>
          <p style={{ color: '#888', fontSize: '0.9rem' }}>
            Try refreshing the page. If the problem persists, let us know.
          </p>
          <button
            onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
            style={{
              padding: '8px 24px', background: '#8BC34A', color: 'white',
              border: 'none', borderRadius: '8px', fontWeight: 700, cursor: 'pointer',
            }}
          >
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
